import {Component} from '@angular/core';

/* Body only -- HelpDialogComponent supplies the dialog chrome and Okay button. */
@Component({
    selector: 'app-status-help',
    templateUrl: './status-help.component.html'
})
export class StatusHelpComponent {
}
